import React, { useEffect, useState } from "react";

export default function BenefitsCard({ item, index }) {
  const selectedLanguage = localStorage.getItem("language");
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div style={{ paddingTop: "8rem" }}>
      <div className="benefits-card-wrapper">
        {screenSize > 1200 ? (
          <div
            className={`row justify-content-between align-items-center ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"} ${
              index % 2 === 1 ? "flex-row-reverse" : "flex-row"
            }`}
          >
            <div className="col-6">
              <div className="icon-wrapper mx-auto d-flex justify-content-center flex-column align-items-center">
                <img width={34} height={44} src={item?.icon} style={{ objectFit: "contain" }} alt="tablet" />
                {item?.showTwoIcons ? <img width={34} height={44} src={item?.icon} style={{ objectFit: "contain" }} alt="tablet" /> : null}
              </div>
              <ul style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                {item?.points?.map((point) => {
                  return <li className="py-3">{selectedLanguage === "arabic" ? point?.arabicLabel : point?.label}</li>;
                })}
              </ul>
            </div>
            <div className="col-6">
              <img src={item?.img} style={{ maxHeight: index === 2 ? "373px" : "auto", objectFit: "contain" }} alt="tablet-img" width={570} />
            </div>
          </div>
        ) : (
          <div
            className={`row justify-content-between flex-column align-items-center ${
              selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"
            }  `}
          >
            <div className="col-12">
              <img src={item?.img} style={{ maxHeight: index === 2 ? "373px" : "auto", objectFit: "contain" }} alt="tablet-img" width={"100%"} />

              <div className="icon-wrapper my-5 mx-auto d-flex flex-column justify-content-center align-items-center">
                <img width={34} height={44} src={item?.icon} style={{ objectFit: "contain" }} alt="tablet" />
                {item?.showTwoIcons ? <img width={34} height={44} src={item?.icon} style={{ objectFit: "contain" }} alt="tablet" /> : null}
              </div>
            </div>
            <div className="col-12">
              <ul style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                {item?.points?.map((point) => {
                  return <li className="py-3">{selectedLanguage === "arabic" ? point?.arabicLabel : point?.label}</li>;
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
